import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { Box, Typography } from "@material-ui/core";
import { BreadcrumbPage } from "../../shared";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CancelIcon from '@mui/icons-material/Cancel';
import ClearIcon from '@mui/icons-material/Clear';
import ZoomOutMapIcon from '@mui/icons-material/ZoomOutMap';
import ctrl from '../Helpsection_images/ctrl.jpg';
import clear from '../Helpsection_images/clear.jpg';
import cancel from '../Helpsection_images/cancel.jpg';
import applyfilter from '../Helpsection_images/applyfilter.jpg';
import updatechart from '../Helpsection_images/updatechart.jpg';
import reset from '../Helpsection_images/reset.jpg';
import Help from "@material-ui/icons/Help";
import Lubricant_Data from '../Helpsection_images/Lubricant_Data.jpg';
import Contaminant from '../Helpsection_images/Contaminant.jpg';
import Wear from '../Helpsection_images/Wear.jpg';
import Additives from '../Helpsection_images/Additives.jpg';
import ISO from '../Helpsection_images/ISO.jpg';
import All_Charts from '../Helpsection_images/All_Charts.jpg';
import shiplist_lube from '../Helpsection_images/shiplist_lube.jpg';
import shiplist_lubeassests from '../Helpsection_images/shiplist_lubeassests.jpg';
import shiplist_lubeassestsclear from '../Helpsection_images/shiplist_lubeassestsclear.jpg';



export default function Helppage() {
    const BreadcrumbList = [{ name: "Trends", url: "" }];
    const [openform,setOpenform]=React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpenForm = () => {
        setOpenform(true);
    };

    const handleClickClose = () => {
        setOpenform(false);
    };
    return(
        <Grid className="breadcrum trends" item xs={12}>
            <BreadcrumbPage rows = {BreadcrumbList} icon={<Help onClick = {handleClickOpenForm} />} />          
            <div>
                <Box component="div" className="pos_relative">
                    
                <Dialog
                open={openform}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
              >
                <DialogTitle id="scroll-dialog-title" color="white">Trends</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                  <DialogContentText
                    id="scroll-dialog-description"
                    //ref={descriptionElementRef}
                    tabIndex={-1}
                  >
                    <p className="subtitle">Help On Filter Panel</p><br />
                    <img className="maxwidth100" src="/assets/images/Trends_page_lube_help_section1.jpg"></img><br /><br />
                    <p>
                      <li>Click and type on the fields to see the options</li><br />
                      <li>For multiple selections hold <img src={ctrl} width="40px" height="40px" /> to select options from the list</li><br />
                      <li>Click <ClearIcon color="disabled" /> to clear all the selection in a particular field<img src={clear} alt="" width="300px" height="300px" /></li><br />
                      <li>Click <CancelIcon color="disabled" /> to remove individual selection in a particular field<img src={cancel} alt="" width="300px" height="300px" /> </li><br />
                      <li>Click on <img src={applyfilter} alt="" width="100px" height="100px" /> to apply selected filters</li><br />
                      <li>Click on <img src={updatechart} alt="" width="100px" height="100px" /> to apply the selected assets list of Updated chart</li><br />
                      <li>Click on <img src={reset} alt="" width="70px" height="70px" /> will revert changes made in filter panel and set it to default global filter values</li><br />
                      <p><span style={{ color: "#ff4717" }}>Note:</span> If global filters are not set then, Reset it will set filter values to blank</p>
                    </p><br />
                    <p className="subtitle">Help On Lube Update Chart</p><br />
                    <img className="maxwidth100" src="/assets/images/Trends_page_lube_help_section2.jpg"></img>
                    <img className="maxwidth100" src="/assets/images/Trends_page_lube_help_section3.jpg"></img><br /><br />
                    <p>
                      <li>Select equipment(machinery) from ship list in left corner</li><br />
                      <li>And can select multiple equipment at the same time from the list <img src={shiplist_lube} alt="" width="120px" height="120px" /></li><br />
                      <li>Click check box in Ship Name to select all equipments in the list <img src={shiplist_lube} alt="" width="120px" height="120px" /></li><br />
                      <li>Selected equipment(machinery) will display on the top as the list <img src={shiplist_lubeassests} alt="" width="170px" height="170px" /></li><br />
                      <li>Click <ClearIcon color="disabled" /> to remove individual selection in the list <img src={shiplist_lubeassestsclear} alt="" width="170px" height="170px" /></li><br />
                      <li>Select any check box(Multiple Selection) in Lubricant Data section <img src={Lubricant_Data} alt="" width="270px" height="270px" /></li><br />
                      <li>Select any check box(Multiple Selection) in Contaminant section <img src={Contaminant} alt="" width="300px" height="300px" /></li><br />
                      <li>Select any check box(Multiple Selection) in Wear section <img src={Wear} alt="" width="270px" height="270px" /></li><br />
                      <li>Select any check box(Multiple Selection) in Additives section <img src={Additives} alt="" width="300px" height="300px" /></li><br />
                      <li>Select any check box(Multiple Selection) in ISO section <img src={ISO} alt="" width="270px" height="270px" /></li><br />
                      <li>Select all dropdown(Single Selection) in All Charts section <img src={All_Charts} alt="" width="270px" height="270px" /></li><br />
                      {/* <li>After selecting equipment and checkbox in each section click on <img src={updatechart} alt="" width="100px" height="100px" /></li><br /> */}
                      <li>After selecting equipment,Chart will displayed in each section related selected check box</li><br />
                      <li>Click on the <ZoomOutMapIcon /> will expand the section and will display only that section</li><br />
                      <li>Click on the <CancelIcon color="primary" /> will close the expanded section</li><br />
                      <li>Click on the dots will open the PDF in another tab ,If there is no pdf(data) will not open</li><br />
                    </p>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClickClose}>Close</Button>
                </DialogActions>
              </Dialog>
                    </Box>
                    </div>
                    </Grid>
    )
}
